<app-sold-out *ngIf="flat && flat.soldOut"></app-sold-out>

<div *ngIf="flat" class="flat-page animated fadeIn" [ngClass]="{'sold-out': flat.soldOut}">

<!--  <button class="ui labeled icon button back-button gold" (click)="backToPrevPage()">-->
<!--    <i class="ui icon arrow left back-icon"></i>-->
<!--    Vissza-->
<!--  </button>-->

  <div class="flat-header remove-padding-under-md">
    <div class="container remove-padding-under-md">
      <div class="layout-and-perspective-container">
        <div class="flat-name-and-buttons-container mt-2 mb-4">

          <!--          <i class="icon facebook square share-button" (click)="shareOnFacebook()"></i>-->


          <app-section-heading [noMargin]="true" [label]="flat.name"></app-section-heading>

          <div class="labels d-flex align-items-center justify-content-center">


            <div class="ui label label price-label solid-shadow" *ngIf="!flat.soldOut">
              {{removeHuf(flat.price | currency : 'HUF' : 'symbol' : '1.0-0')}} Forint
            </div>

            <div class="ui label label solid-shadow overflow-ellipsis">
              <span *ngIf="flat.level === 0">Pinceszint</span>
              <span *ngIf="flat.level === 1">Földszint</span>
              <span *ngIf="flat.level > 1">{{flat.level - 1}}. emelet</span>
            </div>

            <div class="ui label label solid-shadow overflow-ellipsis" *ngIf="flat.garden">
              {{flat.numberOfRooms}} szoba
            </div>

            <div class="ui label label price-label solid-shadow" *ngIf="flat.reserved">
              Foglalt
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="container page remove-padding-under-md">
    <div class="row article-content solid-shadow">

      <div class="col-12 flat-area-details">
        <div class="col-12 flat-summary">
          Összes alapterület: <span class="size">{{flat.size}} m²</span><span
          *ngIf="getTerraceSize()"> + {{getTerraceSize()}} m² terasz</span><span
          *ngIf="flat.garden">+ {{flat.garden}} kertkapcsolat, udvar</span>
        </div>
        <div class="flat-area-wrapper row remove-padding-under-md">

          <div class="col-12 col-md-8 solid-shadow areas">
            <div class="col-12 flat-area" *ngFor="let flatArea of flat.flatAreas, let i = index">
              <div class="row flat-area-row">
                <div class="col-5 name overflow-ellipsis">
                  <div class="number">{{i + 1}}.</div>
                  {{flatArea.name}}
                </div>
                <div class="col-2 size">{{flatArea.size}} m²</div>
                <div class="col-5 coverage overflow-ellipsis">{{flatArea.coverage}}</div>
              </div>
            </div>

          </div>

          <div class="col-12 col-md-4 flat-image-wrapper solid-shadow" (click)="showLightbox(0)">
            <span class="vertical-middle-helper"></span>
            <img [src]="flat.layoutImageUrl">
          </div>

        </div>
      </div>
    </div>

    <app-section-heading [small]="true"
                         class="mt-4 d-block perspective-section-heading"
                         [label]="'Elhelyezekdés és perspektíva'"></app-section-heading>

    <div class="row header-images-row">
      <div class="col-12 col-md-6 flat-image-wrapper solid-shadow p-5" (click)="showLightbox(2)">
        <span class="vertical-middle-helper"></span>
        <img class="position-image"
             [src]="flat.buildingInImageUrl">

        <!--<img [src]="'/assets/images/projects/' + flat.project.toLowerCase() + '/flats/' + flat.id + '_P.jpg'">-->
      </div>
      <div class="col-12 col-md-6 flat-image-wrapper solid-shadow p-5" (click)="showLightbox(1)">
        <!--<img [src]="'/assets/images/projects/' + flat.project.toLowerCase() + '/flats/' + flat.id + '_A.jpg'">-->
        <img [src]="flat.salesImageUrl">
      </div>
    </div>
  </div>

  <!--  <div class="container ui link-to-project">-->
  <!--    <button class="ui button primary" (click)="openProjectPage()">-->
  <!--      <img class="horizont-logo"-->
  <!--           [src]="'/assets/images/projects/horizont/logo.png'">-->

  <!--      Általános információk a Ninetyfour lakóparkról </button>-->
  <!--  </div>-->


  <app-flat-map-section [smallHeader]="true" [highlightedFlat]="flat" *ngIf="!flat.concat"></app-flat-map-section>

  <div class="visualization-wrapper" *ngIf="flat && !flat.concat">
    <img class="visualization-image" (load)="visualizationImageLoaded = true"
         [src]="selectedSide?.imageUrl">

    <div class="highlight-rect"
         *ngIf="flat"
         [style.left.%]="flat?.coordinateX"
         [style.top.%]="flat?.coordinateY">
    </div>

  </div>

  <app-projects-map [disableScroll]="true" [focusOn]="'HORIZONT'"></app-projects-map>

  <ng-image-fullscreen-view
    [images]="galleryImageList"
    [imageIndex]="selectedImageIndex"
    [show]="showFlag"
    (close)="closeEventHandler()"></ng-image-fullscreen-view>


</div>
